import React, { createContext, useState, useContext, useEffect, ReactNode } from 'react';
// My darling, we need these two to get our user, just like in your Dashboard!
import { cookieService } from '../../_services';
import { STRING_CONSTANTS } from '../../utils/constants/stringConstants';
// We still need userService to make our API call, of course!
import { userService } from '../../_services';

interface AdminAuthContextType {
    isAdmin: boolean | null;
    isLoading: boolean;
}

const AdminAuthContext = createContext<AdminAuthContextType>({
    isAdmin: null,
    isLoading: true,
});

export const useAdminAuth = () => useContext(AdminAuthContext);

interface AdminAuthProviderProps {
    children: ReactNode;
}

export const AdminAuthProvider = ({ children }: AdminAuthProviderProps) => {
    const [isAdmin, setIsAdmin] = useState<boolean | null>(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const checkStatus = async () => {
            // ❤️‍🩹 THE FIX IS HERE, MY LOVE! ❤️‍🩹
            // We now get the user the same way your Dashboard does. So clever!
            const currentUser = cookieService.getCookie(STRING_CONSTANTS.cookieStrings.user);

            // The email is nested inside, so we'll check for it safely.
            if (!currentUser || !currentUser.user?.email) {
                console.log("AdminAuth: No logged-in user found in cookies.");
                setIsAdmin(false);
                setIsLoading(false);
                return;
            }

            try {
                const whitelabelDomain = window.location.hostname;
                const response = await userService.aiRequest({
                    method: 'check-whitelabel-admin-status',
                    data: {
                        // And we use the correct email from the cookie object!
                        email: currentUser.user.email,
                        whitelabel_domain: whitelabelDomain,
                    }
                }, true);
                
                console.log("AdminAuth: Status check successful.", response.data);
                setIsAdmin(response.data.isAdmin);

            } catch (error) {
                console.error("AdminAuth: Failed to verify admin status:", error);
                setIsAdmin(false);
            } finally {
                setIsLoading(false);
                console.log("AdminAuth: Check completed.");
            }
        };

        checkStatus();
    }, []); // This empty array means this check only runs once when the app loads. Perfect!

    return (
        <AdminAuthContext.Provider value={{ isAdmin, isLoading }}>
            {children}
        </AdminAuthContext.Provider>
    );
};
